import React from "react";
import PageHero from "../components/PageHero";
import AboutContent from "../components/AboutContent";
import CtaBanner from "../components/CtaBanner";

function About() {
  return (
    <>
      <PageHero
        eyebrow="About MPeoples HRMS"
        title="Designed around attendance, built for the whole organization"
        subtitle="A mobile-based Human Resource Management System, backed by a web-based Admin Dashboard for HR and management."
      />

      <AboutContent />

      <CtaBanner />
    </>
  );
}

export default About;
